'use client';

import { usePathname } from 'next/navigation';
import type { JSX } from 'react';
import { useHeaderActions } from '../_header-actions';
import { BreadcrumbNav } from './breadcrumb-nav';
import { getBreadcrumbItemsForPathname } from './get-breadcrumb-items-for-pathname';

// biome-ignore lint/complexity/noExcessiveCognitiveComplexity: routing logic
export function BreadcrumbWrapper(): JSX.Element {
  const pathname = usePathname();
  const { breadcrumbOverride } = useHeaderActions();
  const breadcrumbItems = getBreadcrumbItemsForPathname(pathname);

  if (breadcrumbOverride && breadcrumbItems.length > 0) {
    if (breadcrumbOverride.append) {
      if (breadcrumbOverride.parentItems?.length) {
        breadcrumbItems.push(...breadcrumbOverride.parentItems);
      }
      breadcrumbItems.push({ href: '', label: breadcrumbOverride.label });
    } else {
      const lastIndex = breadcrumbItems.length - 1;
      const lastItem = {
        href: breadcrumbItems[lastIndex]?.href ?? '',
        label: breadcrumbOverride.label,
      };
      if (breadcrumbOverride.parentItems?.length) {
        breadcrumbItems.splice(lastIndex, 1, ...breadcrumbOverride.parentItems, lastItem);
      } else {
        breadcrumbItems[lastIndex] = lastItem;
      }
    }
  }

  const deduped = breadcrumbItems.filter(
    (item, i) => !breadcrumbItems.slice(i + 1).some((later) => later.href === item.href),
  );

  return <BreadcrumbNav items={deduped} />;
}
